import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdminImportStatusEventImplEncoder } from "../../encoder/AdminImportStatusEventImplEncoder";

import * as CubiqTS from "../../index";
import { AdminImportStatusEvent } from "../AdminImportStatusEvent";

export class AdminImportStatusEventImpl
  extends ConcreteEncodable
  implements AdminImportStatusEvent
{
  public static enType: string = "com.bcdfx.model.event.admin.AdminImportStatusEventImpl";

  /*FID=1*/
  public userCode: string;
  /*FID=2*/
  public uploadId: string;
  /*FID=3*/
  public entityType: CubiqTS.AdminImportType;
  /*FID=4*/
  public importResults: Array<CubiqTS.AdminImportStatusInfo> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdminImportStatusEventImplEncoder.Instance;
    this.setEncodableType(AdminImportStatusEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdminImportStatusEventImpl[" +
      "userCode=" +
      this.userCode +
      "uploadId=" +
      this.uploadId +
      "entityType=" +
      this.entityType +
      "importResults=" +
      this.importResults +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
